import styled from 'styled-components';

export const SCInfoBox = styled.section`
  background-color: ${p => p.theme.rgba('grayLight', 0.2)};
  border: 1px solid ${p => p.theme.color.grayLight};
  border-radius: 3px;
  display: flex;
  margin: 20px 0;
  padding: ${p => p.theme.base.spacing.huge} 40px;
  width: 100%;

  @media (${p => p.theme.mq.mobile}) {
    padding: ${p => p.theme.base.spacing.huge} 18px;
  }
`;

export const SCInfoBoxHeader = styled.div`
  align-items: center;
  display: flex;

  & svg {
    height: 48px;
    margin: 0 20px 0 0;
    width: 48px;

    path {
      fill: ${p => p.theme.color.teal};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/InfoBox/styles.js